import { TableMetricRecords } from '@app/components';
import { Filter, Range, FilterQmOperatorsType } from '@app/components/ui/easy-filter/types';
import { GPTGroupChatObjectType } from '@app/interfaces/gpt-metric-chats.type';
import { GPTGroupObjectType, GptGroupTestResultType } from '@app/interfaces/gpt-metric.type';
import { MetricMetricItem } from '@app/interfaces/metric.type';
import { AnalyticPageOutlet } from '@app/pages/analytics/single-analytic.page';
import { GetFilterParams } from '@app/pages/last-project-records/last-project-records.page';
import { LazyQueryTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import {
  QueryDefinition,
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query';
import { Button, EasyFilterView } from '@ui';
import React, { FC } from 'react';
import { useOutletContext } from 'react-router-dom';

type AiMetricTestingTablePropsType = {
  onCloseModal(): void;
  changeFilterParams: React.Dispatch<React.SetStateAction<GetFilterParams>>;
  filterParams: GetFilterParams;
  handleChangeStep(step: number): void;
  filterKeys: {
    id: string;
    title: string;
    type_value: string;
  }[];
  group?: GPTGroupObjectType | GPTGroupChatObjectType;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  testMetric:
    | LazyQueryTrigger<
        QueryDefinition<
          {
            gpt_group_id: string;
            record_id?: string;
          },
          BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
          'gptGroupsList' | 'gptGroupSingle',
          GptGroupTestResultType,
          'gptMetricApi'
        >
      >
    | LazyQueryTrigger<
        QueryDefinition<
          {
            gpt_group_id: string;
            chat_id?: string;
          },
          BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>,
          'gptGroupsChatList' | 'gptChatGroupSingle',
          GptGroupTestResultType,
          'gptMetricChatApi'
        >
      >;
};

const AiMetricTestingTable: FC<AiMetricTestingTablePropsType> = (props) => {
  const {
    onCloseModal,
    handleChangeStep,
    filterKeys,
    group,
    setLoading,
    testMetric,
    changeFilterParams,
    filterParams,
  } = props;
  // api

  // api
  const { project, currentTemplate } = useOutletContext<AnalyticPageOutlet>();
  const project_id = project?.project_id || '';

  function onChooseRecordToTest(data: {
    record_id: string | undefined;
    chat_id: string | undefined;
  }) {
    if (!group?.gpt_group_id) return;
    const { chat_id, record_id } = data;
    setLoading(true);
    testMetric({ gpt_group_id: group.gpt_group_id, record_id, chat_id })
      .unwrap()
      .then(() => {
        setTimeout(() => setLoading(false), 1000);
        handleChangeStep(2);
      })
      .catch(() => setTimeout(() => setLoading(false), 1000));
  }

  const getTitleFilter = <h2 className="text-1color font-bold">Фильтровать записи проекта</h2>;

  const actionsMarkup = (record: MetricMetricItem) => (
    <div className="flex items-center w-[110px] gap-[15px] justify-center">
      <Button
        onClick={() =>
          onChooseRecordToTest({ chat_id: record?.chat_id, record_id: record?.record_id })
        }
        disabled={!record.calculated}
        label="Выбрать"
      />
    </div>
  );

  return (
    <div className="relative">
      <div className="relative flex flex-col gap-[8px] bg-basic_app_bg p-4 rounded-defaultR">
        <div>
          <EasyFilterView
            data={filterParams.filter}
            titleMarkup={getTitleFilter}
            keysForFiltering={filterKeys}
            onChangeHandler={function (data: Filter & Range & Partial<FilterQmOperatorsType>) {
              changeFilterParams((prev) => ({ ...prev, filter: data }));
            }}
            // handleSubmitSearchWithFilter={onSubmitSearch}
            // handleResetSearch={handleResetSearch}
            // selects={
            //   currentTemplate === 'voice' ? [fullTextSearchSelect[0]] : [fullTextSearchSelect[1]]
            // }
            // disableSearch={!apSearchExceptions}
          />
        </div>
        <div className=" rounded-defaultR ">
          <TableMetricRecords
            apRecords
            withoutLayout
            project_id={project_id}
            currentTemplate={currentTemplate}
            filterParams={filterParams}
            changeFilterParams={changeFilterParams}
            actionsMarkup={actionsMarkup}
            withoutSaveParams
            // hide={!!fullWordSearchTable}
          />
        </div>
      </div>
      <div className="sticky  pb-[24px] pt-[16px] w-full bottom-0 z-[99] bg-white flex items-center justify-end">
        <Button onClick={onCloseModal} label="Вернуться в настройки" />
      </div>
    </div>
  );
};

export default AiMetricTestingTable;
